// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UnitsOfMeasureQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UnitsOfMeasureQuery = { __typename?: 'Query', unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }> };

export type UnitsOfMeasureDataFragment = { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean };

export const UnitsOfMeasureDataFragmentDoc = gql`
    fragment unitsOfMeasureData on UnitOfMeasure {
  id
  name
  useQuantity
}
    `;
export const UnitsOfMeasureDocument = gql`
    query UnitsOfMeasure {
  unitsOfMeasure {
    ...unitsOfMeasureData
  }
}
    ${UnitsOfMeasureDataFragmentDoc}`;

/**
 * __useUnitsOfMeasureQuery__
 *
 * To run a query within a React component, call `useUnitsOfMeasureQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitsOfMeasureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitsOfMeasureQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitsOfMeasureQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnitsOfMeasureQuery, UnitsOfMeasureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitsOfMeasureQuery, UnitsOfMeasureQueryVariables>(UnitsOfMeasureDocument, options);
      }
export function useUnitsOfMeasureLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitsOfMeasureQuery, UnitsOfMeasureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitsOfMeasureQuery, UnitsOfMeasureQueryVariables>(UnitsOfMeasureDocument, options);
        }
export function useUnitsOfMeasureSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitsOfMeasureQuery, UnitsOfMeasureQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitsOfMeasureQuery, UnitsOfMeasureQueryVariables>(UnitsOfMeasureDocument, options);
        }
export type UnitsOfMeasureQueryHookResult = ReturnType<typeof useUnitsOfMeasureQuery>;
export type UnitsOfMeasureLazyQueryHookResult = ReturnType<typeof useUnitsOfMeasureLazyQuery>;
export type UnitsOfMeasureSuspenseQueryHookResult = ReturnType<typeof useUnitsOfMeasureSuspenseQuery>;
export type UnitsOfMeasureQueryResult = Apollo.QueryResult<UnitsOfMeasureQuery, UnitsOfMeasureQueryVariables>;